import { defineMessage } from 'react-intl';

const title = defineMessage({
  id: 'labNavigation.title',
  defaultMessage: 'Lab Content',
});

export default title;
